import { ReactComponent } from "/builds/mb/front/src/app/assets/images/plus.svg?react";
import url from "/builds/mb/front/src/app/assets/images/plus.svg?url";
export { ReactComponent };
export default url;
